import React, { Component } from 'react'
import moment from 'moment-timezone'
import Typography from '@material-ui/core/Typography'
import Timeline from '../components/Timeline/Timeline'
import SnapshotList from '../components/SnapshotList/SnapshotList'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Calendar from 'material-ui-pickers/DatePicker/components/Calendar'
import Switch from 'react-switch'
import { withStyles } from '@material-ui/core/styles'
import { DEFAULT_TIMEZONE } from '../constants'

const styles = theme => ({
  page: {
    display: 'flex',
    height: 'calc(100% - 90px)',
    width: '100%',
    overflow: 'scroll',
  },
  left: {
    padding: '60px 0',
    width: 'calc(50% - 10px)',
  },
  right: {
    padding: '60px 0',
    paddingLeft: 60,
    width: '50%',
    boxSizing: 'border-box',
  },
  verticalDivider: {
    width: 1,
    height: '100%',
    backgroundColor: theme.borderColor,
    position: 'fixed',
    top: 70,
    bottom: 0,
    left: 'calc(50% + 127px)',
    zIndex: 100
  },
  header: {
    fontSize: '1.5rem',
  },
  headerContainer: {
    padding: '0 60px',
    overflow: 'hidden',
    boxShadow: 'none',
    display: 'flex',
    justifyContent: 'space-between'
  },
  weekControls: {
    display: 'flex',
    justifyContent: 'center',
    margin: 15
  },
  weekDates: {
    margin: '0 5px',
    width: 320,
    textAlign: 'center'
  }
})

class History extends Component {
  constructor (props) {
    super(props)

    this.state = {
      date: moment.utc().tz(DEFAULT_TIMEZONE),
      timelineDate: moment.utc().tz(DEFAULT_TIMEZONE),
      monthView: false
    }
  }

  handleDateChange = date => this.setState({date: moment.utc(date)})

  handleTimelineDateChange = date => this.setState({timelineDate: moment.utc(date)})

  handleBothDateChanges = date =>  this.setState({timelineDate: moment.utc(date), date: moment.utc(date)})

  renderMonthView () {
    const { timelineDate } = this.state
    return (
      <div>
        <Paper style={{ overflow: 'hidden', boxShadow: 'none' }}>
          <Calendar
            onlyCalendar
            disableFuture
            allowKeyboardControl
            date={moment.tz(timelineDate, DEFAULT_TIMEZONE)}
            onChange={this.handleBothDateChanges}
          />
        </Paper>
      </div>
    )
  }

  renderWeekView () {
    const { patient, classes } = this.props
    const { date, timelineDate } = this.state
    const earlier = moment.tz(date, DEFAULT_TIMEZONE).subtract('6', 'days')
    const later = moment.tz(date, DEFAULT_TIMEZONE)
    return (
      <div>
        <div className={classes.weekControls}>
          <div onClick={e => this.handleDateChange(moment.tz(date, DEFAULT_TIMEZONE).subtract('1', 'week'))}>{'< '}</div>
          <div className={classes.weekDates}>{earlier.format('MMMM DD YYYY')} to {later.format('MMMM DD YYYY')}</div>
          <div onClick={e => this.handleDateChange(moment.tz(date, DEFAULT_TIMEZONE).add('1', 'week'))}>{' >'} </div>
        </div>
        <SnapshotList patient={patient} timelineDate={timelineDate} date={date} onClick={this.handleTimelineDateChange}/>
      </div>
    )
  }

  renderTimeframeToggle () {
    const toggleStyles = dir => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: "0.75rem",
        [`padding${dir}`]: 6,
        color: 'white',
        fontWeight: 'light'
    })

    return (
      <Switch
        checked={this.state.monthView}
        onChange={e => this.setState({ monthView : !this.state.monthView })}
        offColor="#156879"
        onColor="#156879"
        width={70}
        uncheckedIcon={
          <div
            style={toggleStyles('Right')}
          >
          Week
         </div>
       }
       checkedIcon={
         <div
           style={toggleStyles('Left')}
         >
         Month
        </div>
      }
      />
    )
  }

  render() {
    const { classes, patient } = this.props
    const { temperature_url, ecg_url, respiratory_url } = patient
    const { date, timelineDate } = this.state
    if (!patient) return <div/>
    return (
      <div className={classes.page}>
        <div className={classes.left}>
          <Paper className={classes.headerContainer}>
            <Typography className={classes.header}>History</Typography>
            {this.renderTimeframeToggle()}
          </Paper>
          {this.state.monthView ? this.renderMonthView() : this.renderWeekView()}
        </div>
        <div className={classes.verticalDivider} />
        <div className={classes.right}>
          <Timeline patient={patient} date={timelineDate} displaySummary />
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(History)



// WEBPACK FOOTER //
// ./src/pages/History.js